<template>
    <v-card :class="$style.signInWrapper" width="70%" flat>
        <v-card-text>
            <v-form 
                ref="loginForm" 
                v-model="valid.loginForm" 
                v-on:submit.prevent="login"
                >
                <p :class="$style.loginEmail">
                    <str index="login > label email" />
                </p>
                <v-text-field class="mt-1" v-model="email" outlined type="email" validate-on-blur :rules="rules.validEmail">
                    <v-icon slot="append" :color="validEmail(email)===true ? 'blue' : 'grey'">fa-user</v-icon>
                    <template v-slot:message="{ message }">
                        <str :index="message" />
                    </template>
                </v-text-field>


                <p :class="$style.loginPassword">
                    <str index="login > label password" />
                </p>
                <v-text-field class="mt-1" v-model="password" outlined :type="config.passwordType" required :rules="rules.validPassword" validate-on-blur>
                    <v-icon slot="append" @click="togglePasswordType" v-if="config.passwordType != 'password'">fa-eye</v-icon>
                    <v-icon slot="append" @click="togglePasswordType" v-else>fas fa-eye-slash</v-icon>
                    <template v-slot:message="{ message }">
                        <str :index="message" />
                    </template>
                </v-text-field>

                <v-layout row wrap :class="$style.additionFunctionWrapper">
                    <v-flex xs6>
                        <div :class="$style.rememberWrapper">
                            <v-checkbox 
                                v-model='config.rememberMe' 
                                :disabled="!validEmail(email)" 
                                :class="$style.checkboxAction" />
                            <p :class="$style.checkboxLabel">
                                <str index="login > label remember" />    
                            </p>
                        </div>
                    </v-flex>
                    <v-flex xs6 style="text-align: right;">
                        <div :class="[{[$style.forgetWrapper]: $language() !== 'fr'}, {[$style.forgetWrapperFr]: $language() === 'fr'}]">
                            <a href='#' @click="$emit('forgot_password')">
                                <str :index="'login > forgot password'"/>
                            </a>
                        </div>
                    </v-flex>
                </v-layout>



                <button></button>
            </v-form>
        </v-card-text>

        <v-card-actions :class="$style.loginBtnWrapper">
            <SignInButton 
                v-if="!showAccountValidation"
                    v-on:clicked="login" 
                    :color="config.button_color"
                    :dark="valid_form ? true: false"
                    :button_message="button_message"
                />           
        </v-card-actions> 

        <messaging :display="message.display" :bottom="true" :text="message.text" :timeout="message.timeout" :color="'error'" v-on:closed="message.display=false"/>
    </v-card> 
</template>

<script>
import SignInButton from './signIn_Button.vue';
import HubspotReflectionPoolHandler from '@/Controllers/helper/HubspotReflectionPoolHandler.js'
export default {
    name: 'SignIn',
    components: {
        SignInButton
    },
    mounted: function(){
        this.init();
    },
    data: function(){
        return {
            tab: 'login',
            valid: {
                loginForm: false
            },
            email: null,
            password: null,
            rules: {
                validEmail: [
                    v => !!v && this.validEmail(v) || 'messages > invalid email'
                ],
                validPassword: [
                    v => !!v && v.length>=6 || 'messages > invalid password'
                ]
            },
            config: {
                passwordType: "password",
                rememberMe: false,
                button_color: 'grey'
            },
            button_message: null,
            timers: {},
            counters: {
                failedLogins: 0
            },
            showAccountValidation: false,
            message: {
                display: false,
                text: 'sample text',
                timeout: 3000
            },
        }
    },
    methods: {
        init: function(){
            var self = this;
            self.password = null;
            if(self.$cookie.get('email')){
                self.email = self.$cookie.get('email');
                self.config.rememberMe = true;
            }
            self.resetValidation();
        },
        resetValidation: function(){
            var self = this;
            setTimeout(function(){
                self.$refs.loginForm.validate();
                self.$refs.loginForm.resetValidation();
            },0)            
        },
        validEmail: function(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (email) {
                return re.test(email);  
            }
            return false;
        },
        validPassword: function(password) {
            if (password) {
                return password.length > 6;
            } 
            return false;
        },
        togglePasswordType: function(){
            this.config.passwordType = this.config.passwordType=='password' ? 'text' : 'password';
        },
        passwordIconColor: function(){
            var color = (this.password && this.password.length>=6) ? 'black' : 'grey';
            switch(this.config.passwordType){
                case"text":
                    color = 'blue';
                break;
            }
            return color;
        },
        setButtonColor: function(){
            if(this.valid_form===true){
                this.config.button_color = "#1c94ec";
            }else{
                this.config.button_color = "#d3d3d3";
            }
        },
        login: function(){
            var self = this;
            if(self.$refs.loginForm.validate() && self.$store.getters.busy==0){

                self.$controller.security.user.login(self.email,self.password).then(function(){
                    self.display("Login success");
                    self.counters.failedLogins = 0;
                    self.$controller.view.login.onSuccess();
                    setTimeout(function(){
                        self.$emit('close');
                        self.init();
                    },200);
                    let hubspotFeed = HubspotReflectionPoolHandler.event.addFeed(self.user, 'login', self);
                },function(response){
                    self.counters.failedLogins++;
                    var message = 'ERROR';
                    if(response.foundUser===false){
                        message = "message > user not found";
                    }else if(response.activeUser===false){
                        message = "message > account deactivated";
                    }else if(response.matchPassword===false){
                        message = "message > combination incorrect";
                    }else if(response.validatedAccount===false){
                        message = "message > account not validated";
                        return self.accountUnvalidatedFeed();
                    }
                    self.message.text = self.labels(message);
                    self.message.display = true;
                    self.message.timeout = 3000;
                    self.password = null;
                    self.$refs.loginForm.resetValidation();
                })            
            }
        },
        accountValidationSend: function() {
            var self = this;
            self.$refs.loginForm.validate();
            if(self.valid.loginForm && self.$store.getters.busy==0){
                self.$controller.security.user.sendAccountValidationLink(self.email).then(function(response){
                    self.display("ResendValidation success");
                    setTimeout(function(){
                        self.$emit('resend',response);
                    },200);
                });
            }
        },
        accountUnvalidatedFeed: function(){
            return this.$emit('accountUnvalidatedFeed', this.email);
        },
        display: function(message, color=null, delay=3000){
            var self = this;
            if (message == 'message > account not validated'){
                return this.showAccountValidation = true;
            }
            else {
                if (this.labels(message)){
                    self.button_message = this.labels(message);
                }
            }
            
            if(color){
                self.config.button_color=color;
            }
            clearTimeout(self.timers.button_message);
            self.timers.button_message = setTimeout(function(){
                self.button_message = null;
                self.setButtonColor();
            },delay)
        }
    },
    computed: {
        rememberMe: function(){
            return this.config.rememberMe;
        },
        valid_form: function(){
            return this.validEmail(this.email) && this.validPassword(this.password);
        },
        user: function(){
            return this.$store.getters.user;
        }
    },
    watch: {
        rememberMe: function(){
            if(this.rememberMe){
                this.$cookie.set('email',this.email);
            }else{
                this.$cookie.clear('email');
            }
        },
        valid_form: function(){
            this.setButtonColor();
        }
    }    
}
</script>

<style module>
.signInWrapper {
    margin: 7% auto 0;
}

.loginEmail, .loginPassword {
    margin-bottom: 0px !important;
    margin-left: 0.5%;
    color: black;
}

.additionFunctionWrapper {
    position: relative; 
    top: -20px;
}

    .rememberWrapper {
        margin-left: 7%;
    }

        .checkboxAction {
            display:inline-block !important;
        }

        .checkboxLabel {
            display: inline-block; 
            margin-bottom: 0 !important; 
            position: relative; 
            top: -5px;
        }

    .forgetWrapper {
        margin: 12% 5% 0 0;
    }

    .forgetWrapperFr {
        margin: 12% -10% 0 0;
    }

.loginBtnWrapper {
    position: relative;
    top: -2em;
}

/* No greater than 425px, no less than 360px */
@media (max-width:425px) and (min-width:360px)  {
    .checkboxLabel{
        top: 10px;
        width: 70%;
    }
      /* .forgetWrapper {
        margin: 50% 5% 0 0;
    } */
	}
</style>